(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["xsotica-stock"] && !Shopify.designMode) return;
  try {
    (() => {
    const setup = () => {
      document.querySelectorAll('[data-xsotica-stock]').forEach((stock) => {
        if (stock.dataset.initialized) return;
        const form = document.getElementById('AddToCartForm');
        if (!form) return;
        stock.dataset.initialized = 'true';
        const picker = form.querySelector('.xsotica-length-picker');
        if (picker) picker.after(stock);
        else form.prepend(stock);
        const labels = JSON.parse(stock.querySelector('[data-stock-labels]').textContent);
        const fallback = JSON.parse(stock.querySelector('[data-stock-unavailable]').textContent);
        const label = stock.querySelector('[data-stock-label]');
        const update = (id) => { label.textContent = labels[String(id)] || fallback; };
        document.addEventListener('xsotica:variant-change', (event) => update(event.detail.id));
        form.addEventListener('change', (event) => {
          if (event.target.matches('input[name="xsotica_length"]')) update(event.target.dataset.variantId);
          else if (event.target.matches('[name="id"]')) update(event.target.value);
        });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
    else setup();
    document.addEventListener('shopify:section:load', setup);
  })();
  } catch(e) { console.error(e); }
})();

})();
